<template>
  <div class="communicat_stat" >
    <el-divider content-position="left">产品运营部日报</el-divider>
    <div class="changeHeight m-tabs-content" style="padding:0.2rem 0">
      <el-row type="flex" >
        <el-col :span="2" class="tr m-label text_right" style="width:10%;">选择日期</el-col>
        <el-col :span="6">
          <div>
            <el-date-picker
              v-model="highSearch.dateTime"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="handleDateTimeChange"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="2" :offset="1" class="tr m-label text_right" style="width:10%;">选择人员</el-col>
        <el-col :span="6" >
          <el-select
            :filterable="true"
            collapse-tags
            v-model="highSearch.uid"
            placeholder="请选择人员"
            size="mini" clearable>
            <el-option
              v-for="(item, index) in ConversionPeople"
              :key="index"
              :label="item.username"
              :value="item.id" >
            </el-option>
          </el-select>
        </el-col>
        <el-col class="tr">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button type="primary" size="mini" @click="handleAddOpen">新增</el-button>
          <el-button type="danger" size="mini" @click="handleCloseSearch">重置</el-button>
        </el-col>
      </el-row>
    </div>
    <el-table :data="FlagManage" size="medium" border style="width: 100%">
      <el-table-column label="姓名">
        <template slot-scope="scope">
            <div style="width: 100%">
                <span @click="handleFlagDetail(scope.row.product_diary_id)" class="dot" style="display: inline-block;color: #5787FF;cursor: pointer;">{{ scope.row.adminuser.username }}</span>
            </div>
        </template>
      </el-table-column>
      <el-table-column label="日期">
        <template slot-scope="scope">{{ scope.row.product_diary_date }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              size="mini"
              icon="el-icon-edit"
              type="primary"
              circle
              @click="handleEdit(scope.$index, scope.row)">
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        class="tr mt-10"
        layout="total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
    </el-pagination>
    <!-- 查看 -->
    <el-drawer
      title="查看"
      :visible.sync="singleDataDrawer"
      :direction="direction"
      size="30%">
      <div class="m-tabs-content" style="white-space: pre-wrap;">
        <el-row>
          <el-col class="m-label">日报详情</el-col>
          <el-col>
            <el-input
              type="textarea"
              v-model="singleData.single_desc"
              :autosize="true"
              disabled
              >
            </el-input>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <!-- 新增 -->
    <el-drawer
      title="新增"
      :visible.sync="addDiaryDrawer"
      :direction="direction"
      :before-close="handleAddDrawerClose"
      size="30%">
      <div class="m-tabs-content" style="white-space: pre-wrap;">
        <el-row>
          <el-col class="m-label">新增日报</el-col>
          <el-col>
            <el-input
              type="textarea"
              v-model="addDiaryData.diary"
              placeholder="请输入日报信息..."
              clearable
              :rows="8"
              >
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleAddSave">保存</el-button>
      </div>
    </el-drawer>
    <!-- 编辑 -->
    <el-drawer
      title="编辑"
      :visible.sync="saveDiaryDrawer"
      :direction="direction"
      :before-close="handleEditDrawerClose"
      size="30%">
      <div class="m-tabs-content" style="white-space: pre-wrap;">
        <el-row>
          <el-col class="m-label">编辑日报</el-col>
          <el-col>
            <el-input
              type="textarea"
              v-model="saveDiaryData.diary"
              placeholder="请输入日报信息..."
              clearable
              :rows="8"
              >
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleEditSave">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'WorkDiary',
  data () {
    return {

      FlagManage: [],
      // 产品人员
      ConversionPeople: [],
      // 搜索数据
      highSearch: {
        dateTime: '',
        uid: ''
      },
      // 分页数据
      pageOption: {
        total: 0,
        // 当前页数
        currentPage: 1,
        // 每页显示条数
        pageSize: 10
      },
      direction: 'rtl',
      // 查看页抽屉的显示与隐藏
      singleDataDrawer: false,
      // 新增页抽屉的显示与隐藏
      addDiaryDrawer: false,
      saveDiaryDrawer: false,
      singleData: {
        // 查看单条数据
        single_desc: ''
      },
      addDiaryData: {
        diary: ''
      },
      saveDiaryData: {
        diary: '',
        diaryId: '',
        index: null
      },
      tabData: []
    }
  },
  computed: {
    highSearchStr: function () {
      let str = ''
      for (let key in this.highSearch) {
        str += '&' + key + '=' + this.highSearch[key]
      }
      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    // 关闭新增弹窗
    handleAddDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.addDiaryData.diary = ''
          done()
        })
        .catch(_ => {})
    },
    handleEditDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.saveDiaryData.diary = ''
          this.saveDiaryData.diaryId = ''
          done()
        })
        .catch(_ => {})
    },
    // 列表数据
    handelGetOrders () {
      this.$axios.post('/api/product_diary/product_diary_list?page=' + this.pageOption.currentPage + this.highSearchStr)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.FlagManage = data.data.list.data
            this.ConversionPeople = data.data.adminuser
            this.pageOption.total = data.data.list.total
            this.pageOption.currentPage = data.data.list.current_page
          }
        })
    },
    // 查看单条数据详情
    handleFlagDetail (id) {
      this.singleDataDrawer = true
      this.$axios.get('/api/product_diary/show_single_diary/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.singleData.single_desc = data.data.list.product_diary_log.replaceAll('&lt;br/&gt;', '\n')
          }
        })
    },
    handleAddOpen () {
      this.addDiaryDrawer = true
    },
    handleEdit (index, row) {
      this.saveDiaryDrawer = true
      this.saveDiaryData.index = index
      this.saveDiaryData.diary = row.product_diary_log
      this.saveDiaryData.diaryId = row.product_diary_id
    },
    // 新增保存
    handleAddSave () {
      if (!this.addDiaryData.diary) {
        this.$message.error('日报不填咋行？')
        return
      }
      this.$axios.post('/api/product_diary/add_single_diary', {
        product_diary_log: this.addDiaryData.diary
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.handelGetOrders()
            this.$message.success(data.msg)
            this.addDiaryData.diary = ''
            this.addDiaryDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 编辑保存
    handleEditSave () {
      if (!this.saveDiaryData.diary) {
        this.$message.error('日报不填咋行？')
        return
      }
      this.$axios.post('/api/product_diary/update_single_diary/' + this.saveDiaryData.diaryId, {
        product_diary_log: this.saveDiaryData.diary
      })
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.handelGetOrders()
            this.$message.success(data.msg)
            this.saveDiaryData.diary = ''
            this.saveDiaryDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 分页操作
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.handelGetOrders()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.handelGetOrders()
    },
    // // 日期控件
    // pickerDataChange (val) {
    //   if (!val) {
    //     this.highSearch.dateTime = ''
    //     this.pageOption.currentPage = 1
    //     this.handelGetOrders()
    //   } else {
    //     this.highSearch.dateTime = val
    //     this.pageOption.currentPage = 1
    //     this.handelGetOrders()
    //   }
    // },
    handleDateTimeChange () {
      this.pageOption.currentPage = 1
      this.handelGetOrders()
    },
    // 搜索
    handleSearch () {
      this.handelGetOrders()
    },
    // 重置
    handleCloseSearch () {
      this.highSearch.dateTime = ''
      this.highSearch.uid = ''
      this.handelGetOrders()
    }
  },
  mounted () {
    this.handelGetOrders()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span {
    color: #5789F4;
    font-size: 0.36rem;
    font-weight: 400;
  }
  .public
    box-sizing border-box
    display flex
    width 100%
  .communicat_stat
    marginLeft()
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .tr
    text-align: right
  .m-tabs-content
    overflow-y auto
    padding 0 .4rem
    box-sizing border-box
    .m-label
      line-height: .64rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
  .communicat_stat >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  /*.clues_manage >>> .el-table__header thead .is-hidden*/
  /*  color: red*/
  /*  background-color: #ECF4FF*/
  /*  font-size 16px*/
  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem
  .mt-10
    margin-top: .2rem
  .level
    display flex
    align-items center
    position relative
    padding-right .32rem
    img
      width .32rem
      height .30rem
    .el-icon-question
      margin-left: .1rem
      color: #409EFF
      position absolute
      top 0
      right 0
      cursor pointer
  .el-select, .el-cascader
    width: 100%
  .count
    padding-left: .2rem
    line-height: .56rem
  .el-position
    position relative
    .dot
      display inline-block
      width 0.1rem
      height 0.1rem
      border-radius 50%
      margin-right 0.1rem
      position absolute
      top 0
      left -.2rem
      bottom 0
      margin auto
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .changeHeight
    padding .2rem
    margin-top .4rem
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .el-collapse >>> .el-collapse-item__content
    padding-bottom 0
  .el_dialogs >>> .el-dialog__body
    padding-left 0
    padding-right 0
  .el_dialogs >>> .el-dialog__header
    padding 0
  .el-icon-chat-dot-square
    color: #88D023
  .block
    height auto
    overflow-y auto
    padding-top .2rem
    padding-left .2rem
    box-sizing border-box
    .m_comment
      padding .2rem .4rem
      flex-direction column
      margin-bottom .2rem
      background #f3f3f3
      height auto
      border-radius .09rem
      .comment_name_time
        margin-bottom .4rem
        display flex
        flex-direction row
        justify-content space-between
        line-height .5rem
        span
          color: rgb(102, 102, 102)

    .time_right
      width 100%
      margin-top .4rem
      overflow hidden
      word-break break-all
      white-space normal
    .time_line
      line-height .5rem
  .popoverSpan:hover
    color: rgb(87, 135, 255)
  .el-timeline-item__node--large
    width .4rem
    height .4rem
  /*滚动条整体样式*/
  ::-webkit-scrollbar{
    width: .1rem;/*竖向滚动条的宽度*/
    height: 10px;/*横向滚动条的高度*/
  }
  ::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track{/*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .el-date-editor
    width: 100% !important
  .addCon
    padding: .4rem
    text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/work_diary/WorkDiary.vue